import React from 'react';
import '../styles/ProductColors.css';

const ProductColors = ({ 
  colors = [],           // Tableau de couleurs (ex: ['#ff0000', '#00ff00', '#0000ff'])
  selectedColor = null,  // Couleur actuellement sélectionnée (optionnel)
  onSelectColor = () => {} // Callback lors de la sélection d'une couleur (optionnel)
}) => {
  return (
    <div className="product-colors">
      {colors.map((color, index) => (
        <div
          key={index}
          className={`color-circle ${selectedColor === color ? 'selected' : ''}`}
          style={{ backgroundColor: color }}
          onClick={() => onSelectColor(color)}
          title={color}
        />
      ))}
    </div>
  );
};

export default ProductColors;
